import type { PropsWithChildren } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { css } from 'styled-components';

import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { PageDesignWrapper, PillDiamondDesign, RoundPillDesign } from './styles';

interface PillsBackgroundProps
  extends PropsWithChildren<{
    isMobile: boolean;
    key: string;
  }> {}

/**
 * Note: This can be used in conjunction with Standard Page as this only adds absolute position
 * elements on the page
 * @param param.design Renders a page design
 * @param param.children children of component to be rendered
 */
const PillsBackground = ({ children, isMobile, key }: PillsBackgroundProps) => {
  return (
    <PageDesignWrapper>
      <AnimatePresence exitBeforeEnter>
        <motion.div
          css={css`
            height: 100%;
            ${({ theme }) => theme.mediaQueries.small} {
              top: 0;
              overflow-y: auto;
              min-height: 100vh;
              height: auto;
            }
          `}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeIn' }}
          key={key}
        >
          {isMobile && (
            <>
              <RoundPillDesign iconString={CAPSULE_ICON_STRINGS.pill_circle} raw />
              <PillDiamondDesign iconString={CAPSULE_ICON_STRINGS.pill_diamond} raw />
            </>
          )}

          {children}
        </motion.div>
      </AnimatePresence>
    </PageDesignWrapper>
  );
};

export { PillsBackground };
